var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 26C43.983 26 31 31.9841 31 39.3662V40.6765C32.6019 46.046 43.837 51.3378 60 51.3378C76.1613 51.3378 87.3964 46.046 89 40.6765V39.3662C89 31.9841 76.0153 26 60 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45.7319C36.0686 50.74 47.0153 54.1305 60 54.1305C72.9847 54.1305 83.9314 50.74 89 45.7319V54.4142C87.3964 59.7837 76.1613 65.0755 60 65.0755C43.837 65.0755 32.6019 59.7837 31 54.4142V45.7319Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 59.4696C36.0686 64.4777 47.0153 67.8682 60 67.8682C72.9847 67.8682 83.9314 64.4777 89 59.4696V67.6825C87.3964 73.052 76.1613 78.3438 60 78.3438C43.837 78.3438 32.6019 73.052 31 67.6825V59.4696Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 72.7379C36.0686 77.746 47.0153 81.1365 60 81.1365C72.9847 81.1365 83.9314 77.746 89 72.7379V79.6338C89 87.0159 76.0153 93 60 93C43.983 93 31 87.0159 31 79.6338V72.7379Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinFull);
export default __webpack_public_path__ + "static/media/coinFull.1bd1a54345f468abc9194b95432802d1.svg";
export { ForwardRef as ReactComponent };